/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
    "/api/v1/activity-analytics/summary": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns aggregate engagement KPIs (counts only) for a channel over a recent window. */
        get: operations["42d0bf78ea3db50882677e410454992a"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/activitylogs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Search activity logs by player_id, transactional email identifier, and state */
        get: operations["8d698586c4921dfb2baa30b8952f4c23"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/activitylogs/{userId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Fetches activity logs for user */
        get: operations["e12c01d4a71edb1a1ef4e6928f7e32e3"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/gateway/sms-consent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Handle SMS consent unsubscribe requests from Gateway API
         * @description Processes unsubscribe requests received via SMS from Gateway API and updates user consent status accordingly.
         */
        post: operations["f79a6072af1033caa490eeb013b62b32"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/ortto/activity/log": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Logs an activity to Ortto */
        post: operations["7dc67644bddc0ed2eca2218f8abe2410"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/ortto/journey/log": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Logs a journey activity to MA */
        post: operations["89be693abd2c9456c0742bdac226b988"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/ortto/promotion": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Handles call from Ortto to claim a promotion */
        post: operations["a8d01248c0368bbe66b219f5f896cd1b"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/ortto/push-notification": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Handles call from Ortto to claim a promotion */
        post: operations["0cc00f7fcf940f2b4155dd5766727d93"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/ortto/trustpilot": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["f0f534d8f7d90973d93226e3b4cd7b4c"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/sendgrid/activity/log": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Logs an activity to Ortto */
        post: operations["366057c92212b1d329c05d2e62ac426d"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/sendgrid/unsubscribe": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Handles SendGrid Event Webhook batches. Iterates over the posted
         *     events and, for each unsubscribe or group_unsubscribe event,
         *     drops the recipient's marketing consent and queues a delayed
         *     removal from SendGrid's global unsubscribe list so transactional
         *     mail can still be delivered.
         */
        post: operations["59e91f8f57d8387a8aeda10d9e254a9d"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/subscribe/email/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Handles callback from Ortto when a user unsubscribes via email */
        post: operations["79cbbd4f58f198754160cd576d0392cc"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/subscribe/sms/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Handles callback from Ortto when a user unsubscribes via sms */
        post: operations["c03f0ac1cb710977531905756c20923f"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/unsubscribe/email/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Handles callback from Ortto when a user unsubscribes via email */
        post: operations["97bcfdfdf45b575c9185d0b89a370fd2"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/callbacks/unsubscribe/sms/{type}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Handles callback from Ortto when a user unsubscribes via SMS */
        post: operations["94cd7d3bcc0e12ffeee53e8fcc1001a0"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/consent": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Returns consent of user(s) based on query parameter or arguments. */
        get: operations["ca2da4a2861587fa776ae99c11e42eb0"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/consent/flags": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** @deprecated */
        post: operations["47ab795e67cb422b06bb93debddb73d2"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/contact-field-audits/{playerId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Field-change audit rows (and contact-created audits) for every contact
         *     sharing the given player_id, newest first.
         */
        get: operations["65a0525e6584c69971cf1ef7dd745fe2"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/contacts/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Updates the contact */
        post: operations["ea396a5b3567557cd28f748225c923de"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/contacts/{email}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Updates a contact with the given email
         * @deprecated
         * @description Use '/api/v1/contacts/' instead
         */
        post: operations["7ec1b8216380004613962ced7aeacf81"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/contacts/amount": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get: operations["6beabf66c709169e52ecd7716583e147"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/contacts/bulk": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["3c0ed4d830f0ddb45c470509e6baddde"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/contacts/count": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Returns a count of contacts matching the given query.
         * @description Paired with `/contacts/get` (which deliberately avoids COUNT(*) by
         *     defaulting to `simplePaginate`). Body shape mirrors `/contacts/get`'s
         *     `query` field, so callers can reuse predicates. Backs CRM's
         *     `MarketingAutomationClient::countPlayers()` and the marketer-facing
         *     `/segments/{slug}/cardinality` endpoint.
         *
         *     `explain: true` adds the compiled SQL to the response, bindings interpolated
         *     so it is runnable as-is. Backs CRM's entry-conditions SQL export, where an
         *     author reconciling a surprising audience size needs to see the query that
         *     produced it — relative-time literals included, already resolved.
         */
        post: operations["d551e135405a5da8981d478cf40c7dfd"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/contacts/fields": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Returns the contact-field catalog (name, type, transient/internal flags, optional enum values, category).
         * @description Source-of-truth is the `fields` table (Eloquent `Field` model), seeded
         *     via {@see \Database\Seeders\FieldTableSeeder} and extended at runtime by
         *     {@see Field::registerField()}. Enum values come from `config('ortto.enums')`
         *     — present when the field name has an entry there, omitted otherwise.
         *     Fields with `is_crm_visible = false` are excluded from the catalog;
         *     marketing staff opt fields out on the admin fields page.
         *
         *     Consumed by CRM's `MarketingAutomationClient::fields()` and the journey
         *     builder / segment predicate UI.
         */
        get: operations["e35c238c3131b07eb4d7a88fd70b03b6"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/contacts/get": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Returns contacts with fields from the given arguments */
        post: operations["7d1311d47ebf21b8d94d56026fa068fb"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/email/{user_id}/send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Sends a transactional email to the given email-address */
        post: operations["c40b332e83f3beaf06e7c7861403f2c8"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/email/{user_id}/send-marketing": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Queue a marketing email for bulked delivery to SendGrid.
         * @description Unlike transactional /send, the caller supplies the SendGrid
         *     template_id directly (templates are managed in CRM and uploaded via
         *     /email/designs). Inserts a pending_marketing_mails row; the
         *     send:bulk-marketing-emails cron drains the table.
         */
        post: operations["04d14b16927f8611a808d8aa7ecf1cba"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/email/designs": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Publish a compiled HTML email design to the configured email provider
         *     and return the resulting `name`, Dynamic Template id, and version id.
         * @description Called by CRM's PublishService inside a publish transaction so the
         *     returned identifiers can be stored on the `email_template_versions`
         *     row in the same commit.
         *
         *     The `name` is composed as `{brand}_{slug}` so the convention lives in
         *     marketing-automation alongside the cleanup safety regex.
         */
        post: operations["c92eec39f03664c79906ae92e31b0a10"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/email/designs/cleanup": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Delete SendGrid Dynamic Templates whose names match the MA
         *     `{brand}_{slug}` convention but aren't in the supplied allow-list.
         * @description Driven by CRM's hourly `email:cleanup-sg-orphans` cron.
         */
        post: operations["2aec4e4c79dcdd1080fd3128dc8a9dce"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/email/designs/delete": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Delete SendGrid Dynamic Templates by id (idempotent). Called by CRM when
         *     an email template is archived, to remove its provider-side templates
         *     immediately. A 404 for an already-deleted id counts as deleted.
         */
        post: operations["1652c017fae90cfe3e9783b529a558f5"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/email/test-send": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Send a one-off inline-HTML test email to a single recipient using the
         *     brand's verified sender. Used by CRM's email-builder test-send, where the
         *     draft has no Dynamic Template id yet. Returns SendGrid's `X-Message-Id`
         *     (null when the provider does not return one).
         * @description Optional from_email/from_name (both required together) and ip_pool let
         *     CRM carry a brand-theme sender/pool that overrides the config default.
         */
        post: operations["aad19c5f00b2980f9978e90662409236"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/journey/trigger": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Trigger journey */
        post: operations["67c3726617e5fe57ba05a81135052320"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/message-events/{playerId}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** Fetches message events for the given player, grouped by message. */
        get: operations["bf9562c8b361dc3cc419b96dff7ee5bd"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/public/apple/ads/attribution/token": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /** Upsert Apple Ads Attribution Token */
        post: operations["871b0318e1410a8924107dd9f3125e50"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/public/apptoken/": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        post: operations["3a6292e27ffb4259acfe5e37e4b9c23c"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/public/unsubscribe/{token}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /**
         * Get the consent state for a consent-link token
         * @description Unauthenticated and rate limited per IP and per token. Any invalid, revoked or tampered token returns the identical 404 response, so an attacker cannot learn whether a token was ever valid.
         */
        get: operations["b3a35838f3e5b58b753f570baaaccaa1"];
        put?: never;
        post?: never;
        delete?: never;
        options?: never;
        head?: never;
        /**
         * Update one consent type for a consent-link token
         * @description Unauthenticated and rate limited per IP and per token. The token is validated before the body, so an invalid token still yields 404, never 422.
         */
        patch: operations["80f848baa6b17a4eb18aa397ebca3b85"];
        trace?: never;
    };
    "/api/v1/public/unsubscribe/{token}/all": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Unsubscribe from every consent type for this token
         * @description Unauthenticated, idempotent and rate limited per IP and per token. This is the target of the List-Unsubscribe-Post one-click header sent with marketing emails.
         */
        post: operations["644120ac200ec26bd6dc753b1be5a719"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/unsubscribe/revocations": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Revoke every open consent-link token issued to a player
         * @description Backoffice endpoint used to invalidate previously sent consent-link emails for a player, for example after a support request. Reached by backoffice operators through the service's SSO, like every other endpoint in this API.
         */
        post: operations["7f9749d08f863b2e8316628bed38236d"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
    "/api/v1/user/{user_id}": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        get?: never;
        put?: never;
        /**
         * Updates a contact with the given userId
         * @deprecated
         * @description Use '/api/v1/contacts/' instead
         */
        post: operations["b2e0ad98655c96c1104d4af2003d4ab4"];
        delete?: never;
        options?: never;
        head?: never;
        patch?: never;
        trace?: never;
    };
}
export type webhooks = Record<string, never>;
export interface components {
    schemas: {
        ConsentLinkState: {
            consents?: {
                /** @example true */
                enabled?: boolean;
                /**
                 * @example email
                 * @enum {string}
                 */
                type?: ConsentLinkStateConsentsType;
            }[];
        };
        SendgridEventRequest: {
            /** @example sijc@cego.dk */
            email?: string;
            /** @example deferred */
            event?: string;
            /** @example noreply@spilnu.dk */
            from?: string;
            /** @example  */
            reason?: string;
            /** @example 1 */
            sg_message_id?: string;
            /** @example spilnu_password_reset_mail */
            sg_template_name?: string;
            /** @example 1765287365 */
            timestamp?: number;
        };
    };
    responses: never;
    parameters: never;
    requestBodies: never;
    headers: never;
    pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
    "42d0bf78ea3db50882677e410454992a": {
        parameters: {
            query?: {
                /** @description Channel to summarise */
                channel?: PathsApiV1ActivityAnalyticsSummaryGetParametersQueryChannel;
                /** @description Window length in days (1-30) */
                days?: number;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Aggregate engagement KPIs for the window */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "8d698586c4921dfb2baa30b8952f4c23": {
        parameters: {
            query: {
                /** @description Maximum number of results (default: 100) */
                limit?: number;
                /** @description Order direction for sent_at (desc or asc) */
                orderBy?: string;
                /** @description Player ID */
                player_id: string;
                /** @description Activity log state */
                state: string;
                /** @description Transactional email identifier */
                transactional_email_identifier: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Activity logs matching the search criteria */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description No contact found for player_id */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    e12c01d4a71edb1a1ef4e6928f7e32e3: {
        parameters: {
            query?: {
                /** @description Items per page */
                perPage?: string;
                /** @description Use simple pagination (no total count) */
                simplePaginate?: boolean;
            };
            header?: never;
            path: {
                /** @description User ID */
                userId: number;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Getting all logs for user */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    f79a6072af1033caa490eeb013b62b32: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /** @description The country prefix of the phone number */
                    country_prefix: string;
                    /** @description The content of the SMS message */
                    message: string;
                    /** @description The phone number of the user sending the SMS */
                    msisdn: string;
                };
            };
        };
        responses: {
            /** @description Consent update processed successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized request */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "7dc67644bddc0ed2eca2218f8abe2410": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /** @description activity */
                    activity: {
                        /** @description Attributes */
                        attr: {
                            /**
                             * @description kind
                             * @example true
                             */
                            "bol:a2:et"?: boolean;
                            /**
                             * @description identifier
                             * @example
                             */
                            "idt::ds"?: string;
                            /**
                             * @description email id
                             * @example 1612796424-5f4d8b8f-6a1e-11eb-bf7a-fa9d288487ad
                             */
                            "str:a2:ei"?: string;
                            /**
                             * @description email name
                             * @example transactional_password_reset_mail
                             */
                            "str:a2:en"?: string;
                            /**
                             * @description journey id
                             * @example b0eeb798-9325-459a-b0e5-a02b17b91eae
                             */
                            "str:a2:ji"?: string;
                            /**
                             * @description journey name
                             * @example Password reset mail
                             */
                            "str:a2:jn"?: string;
                        }[];
                        /**
                         * @description field id
                         * @example act:a2:es
                         */
                        field_id: unknown;
                    }[];
                    /** @description contact */
                    contact: {
                        /**
                         * @description Email
                         * @example John@Doe.com
                         */
                        email: Record<string, never>;
                    }[];
                };
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "89be693abd2c9456c0742bdac226b988": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /** @description activity */
                    activity: {
                        /** @description Attributes */
                        attr: {
                            /**
                             * @description journey id
                             * @example 68aecf50c979d8efd22c6f13
                             */
                            "idt::c": string;
                            /**
                             * @description journey run id
                             * @example 1068aed11900000000000000
                             */
                            "idt::jri": string;
                        };
                        /**
                         * @description field id
                         * @example act::ej
                         */
                        field_id: unknown;
                    };
                    /** @description contact */
                    contact: {
                        /**
                         * @description User ID for the MA backend
                         * @example 244466666
                         */
                        user_id: number;
                    };
                    /**
                     * @description Date and time the activity occurred. Ortto uses a very precise timestamp, but we granulate to YYYY-MM-DD HH:MM:SS, so that format is fine
                     * @example 2025-08-29T06:01:22.702919997Z
                     */
                    time: string;
                };
            };
        };
        responses: {
            /** @description Logged Journey Activity */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example Logged */
                        message?: string;
                        /** @example true */
                        success?: boolean;
                    };
                };
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    a8d01248c0368bbe66b219f5f896cd1b: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /**
                     * @description activity
                     * @example 1
                     */
                    activity: unknown;
                    /**
                     * @description contact
                     * @example 232
                     */
                    contact: unknown;
                };
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "0cc00f7fcf940f2b4155dd5766727d93": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /**
                     * @description Brand
                     * @example spilnu
                     */
                    current_brand: unknown;
                    /**
                     * @description Player ID
                     * @example UUID
                     */
                    player_id: unknown;
                    /**
                     * @description Push Notification Body
                     * @example Some Body
                     */
                    push_notification_body: unknown;
                    /**
                     * @description Push Notification Subtitle
                     * @example Some Subtitle
                     */
                    push_notification_subtitle?: unknown;
                    /**
                     * @description Push Notification Title
                     * @example Some Title
                     */
                    push_notification_title: unknown;
                    /**
                     * @description Push Notification URL
                     * @example Some URL
                     */
                    push_notification_url: unknown;
                };
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    f0f534d8f7d90973d93226e3b4cd7b4c: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SendgridEventRequest"][];
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "366057c92212b1d329c05d2e62ac426d": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": components["schemas"]["SendgridEventRequest"][];
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "59e91f8f57d8387a8aeda10d9e254a9d": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /**
                     * Format: email
                     * @example john@doe.com
                     */
                    email: string;
                    /** @example unsubscribe */
                    event: string;
                }[];
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "79cbbd4f58f198754160cd576d0392cc": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Unsubscription type */
                type: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /**
                     * @description Email
                     * @example John@Doe.com
                     */
                    email: Record<string, never>;
                };
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    c03f0ac1cb710977531905756c20923f: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Subscription type (casino, bingo or null/all) */
                type: PathsApiV1CallbacksSubscribeSmsTypePostParametersPathType;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /**
                     * Format: email
                     * @description Email address
                     * @example John@Doe.com
                     */
                    email: string;
                };
            };
        };
        responses: {
            /** @description Subscribed successfully */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "97bcfdfdf45b575c9185d0b89a370fd2": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Unsubscription type */
                type: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /**
                     * @description Email
                     * @example John@Doe.com
                     */
                    email: Record<string, never>;
                };
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "94cd7d3bcc0e12ffeee53e8fcc1001a0": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Unsubscription type */
                type: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /**
                     * @description Email
                     * @example John@Doe.com
                     */
                    email: Record<string, never>;
                };
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ca2da4a2861587fa776ae99c11e42eb0: {
        parameters: {
            query?: {
                /** @description page number */
                page?: number;
                /** @description Per page */
                perPage?: number;
                /** @description User Id or Ids */
                userIds?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Consent List */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "47ab795e67cb422b06bb93debddb73d2": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /**
                     * @description Current Flags
                     * @example {
                     *       "flagged_as_reject_advertisement": true,
                     *       "flagged_as_permanent_marketing_black_listed": false,
                     *       "flagged_as_excluded_from_gambling": false,
                     *       "flagged_as_high_risk": true,
                     *       "flagged_as_suspected_fraudster": false
                     *     }
                     */
                    current_flags?: Record<string, never>;
                    /**
                     * @description Player Id
                     * @example 12315
                     */
                    player_id: string;
                    /**
                     * @description User Id
                     * @example 1
                     */
                    user_id: number;
                }[];
            };
        };
        responses: {
            /** @description Updated Flags */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "65a0525e6584c69971cf1ef7dd745fe2": {
        parameters: {
            query: {
                /** @description Bare field names to include (tags filter) */
                "fields[]": string[];
                /** @description created_at lower bound (ISO 8601) */
                from?: string;
                /** @description Rows per page */
                perPage?: number;
                /** @description created_at upper bound (ISO 8601) */
                to?: string;
            };
            header?: never;
            path: {
                /** @description Player ID */
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Audit rows */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    ea396a5b3567557cd28f748225c923de: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /**
                     * @description Active Bonus Code
                     * @example BONUSCODE123
                     */
                    active_bonus_code?: string;
                    /**
                     * @description Active Bonus Type
                     * @example Type B
                     */
                    active_bonus_type?: string;
                    /**
                     * @description Address
                     * @example
                     */
                    address?: string;
                    /**
                     * @description Age
                     * @example 20
                     */
                    age?: number;
                    /**
                     * Format: number
                     * @description Amount Spent Last 14 Days
                     * @example 300
                     */
                    amount_spent_last_14_days?: unknown;
                    /**
                     * Format: number
                     * @description Amount Spent Last 30 Days
                     * @example 600
                     */
                    amount_spent_last_30_days?: unknown;
                    /**
                     * Format: number
                     * @description Amount Spent Last 60 Days
                     * @example 1200
                     */
                    amount_spent_last_60_days?: unknown;
                    /**
                     * Format: float
                     * @description Balance
                     * @example 150.75
                     */
                    balance?: number;
                    /**
                     * @description City
                     * @example
                     */
                    city?: string;
                    /**
                     * @description Customer Number
                     * @example AB123456
                     */
                    customer_number?: string;
                    /**
                     * Format: number
                     * @description Deposit Amount Last 30 Days
                     * @example 200
                     */
                    deposit_amount_last_30_days?: unknown;
                    /**
                     * @description Email
                     * @example John@Doe.com
                     */
                    email?: string;
                    /**
                     * @description First Name
                     * @example John
                     */
                    first_name?: string;
                    /**
                     * Format: boolean
                     * @description Has Made Deposit
                     * @example true
                     */
                    has_made_deposit?: unknown;
                    /**
                     * Format: boolean
                     * @description Has Played Live Casino
                     * @example true
                     */
                    has_played_live_casino?: unknown;
                    /**
                     * Format: date-time
                     * @description Last Activity Date
                     * @example 2020-01-01 00:00:00
                     */
                    last_activity_date?: string;
                    /**
                     * @description Last Name
                     * @example Doe
                     */
                    last_name?: string;
                    /**
                     * @description Latest Bonus Code Consumed
                     * @example BONUSCON123
                     */
                    latest_bonus_code_consumed?: string;
                    /**
                     * Format: date-time
                     * @description Latest Login Date
                     * @example 2020-01-01 00:00:00
                     */
                    latest_login_date?: string;
                    /**
                     * @description Mobile
                     * @example
                     */
                    mobile?: string;
                    /**
                     * @description Most Played Game Last 14 Days
                     * @example
                     */
                    most_played_game_last_14_days?: string;
                    /**
                     * @description Most Popular Game Last 30 Days
                     * @example Game B
                     */
                    most_popular_game_last_30_days?: string;
                    /**
                     * @description Name
                     * @example John Doe
                     */
                    name?: string;
                    /**
                     * @description Old Email
                     * @example John@Doe.com
                     */
                    old_email?: string;
                    /**
                     * @description Partner Name
                     * @example Partner A
                     */
                    partner_name?: string;
                    /**
                     * Format: number
                     * @description Pending Bonus Amount
                     * @example 100.5
                     */
                    pending_bonus_amount?: unknown;
                    /**
                     * Format: number
                     * @description Pending Bonus Minimum Deposit
                     * @example 50
                     */
                    pending_bonus_minimum_deposit?: unknown;
                    /**
                     * @description Pending Bonus Type
                     * @example Type A
                     */
                    pending_bonus_type?: string;
                    /**
                     * @description Player ID
                     * @example 12345
                     */
                    player_id: string;
                    /**
                     * @description Recent Jackpot Game
                     * @example Game A
                     */
                    recent_jackpot_game?: string;
                    /**
                     * Format: date-time
                     * @description Sent At
                     * @example 2020-01-01 00:00:00
                     */
                    sent_at: string;
                    /**
                     * @description Sex
                     * @example male
                     */
                    sex?: string;
                    /**
                     * @description Sign Up Code
                     * @example CODE123
                     */
                    sign_up_code?: string;
                    /**
                     * Format: date-time
                     * @description Signed Up Date
                     * @example 2020-01-01 00:00:00
                     */
                    signed_up_date?: string;
                    /**
                     * Format: date-time
                     * @description SMS Consent Given Date
                     * @example 2020-01-01 00:00:00
                     */
                    sms_consent_given_date?: string;
                    /**
                     * @description SMS Link
                     * @example http://example.com/sms-link
                     */
                    sms_link?: string;
                    /**
                     * @description Sub Partner Name
                     * @example Sub Partner B
                     */
                    sub_partner_name?: string;
                    /**
                     * @description User Id
                     * @example 2
                     */
                    user_id: number;
                    /**
                     * @description Verification Code
                     * @example VER123
                     */
                    verification_code?: string;
                    /**
                     * @description Zipcode
                     * @example
                     */
                    zipcode?: string;
                };
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Provided argument is not an email */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "7ec1b8216380004613962ced7aeacf81": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Current email of the contact */
                email: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /**
                     * @deprecated
                     * @description Active Bonus Code
                     * @example BONUSCODE123
                     */
                    active_bonus_code?: string;
                    /**
                     * @deprecated
                     * @description Active Bonus Type
                     * @example Type B
                     */
                    active_bonus_type?: string;
                    /**
                     * @deprecated
                     * @description Address
                     * @example
                     */
                    address?: string;
                    /**
                     * @deprecated
                     * @description Age
                     * @example 20
                     */
                    age?: number;
                    /**
                     * Format: number
                     * @deprecated
                     * @description Amount Spent Last 14 Days
                     * @example 300
                     */
                    amount_spent_last_14_days?: unknown;
                    /**
                     * Format: number
                     * @deprecated
                     * @description Amount Spent Last 30 Days
                     * @example 600
                     */
                    amount_spent_last_30_days?: unknown;
                    /**
                     * Format: number
                     * @deprecated
                     * @description Amount Spent Last 60 Days
                     * @example 1200
                     */
                    amount_spent_last_60_days?: unknown;
                    /**
                     * Format: float
                     * @deprecated
                     * @description Balance
                     * @example 150.75
                     */
                    balance?: number;
                    /**
                     * @deprecated
                     * @description City
                     * @example
                     */
                    city?: string;
                    /**
                     * @deprecated
                     * @description Customer Number
                     * @example AB123456
                     */
                    customer_number?: string;
                    /**
                     * Format: number
                     * @deprecated
                     * @description Deposit Amount Last 30 Days
                     * @example 200
                     */
                    deposit_amount_last_30_days?: unknown;
                    /**
                     * @deprecated
                     * @description Email
                     * @example John@Doe.com
                     */
                    email?: string;
                    /**
                     * @deprecated
                     * @description First Name
                     * @example John
                     */
                    first_name?: string;
                    /**
                     * Format: boolean
                     * @deprecated
                     * @description Has Made Deposit
                     * @example true
                     */
                    has_made_deposit?: unknown;
                    /**
                     * Format: boolean
                     * @deprecated
                     * @description Has Played Live Casino
                     * @example true
                     */
                    has_played_live_casino?: unknown;
                    /**
                     * Format: date-time
                     * @deprecated
                     * @description Last Activity Date
                     * @example 2020-01-01 00:00:00
                     */
                    last_activity_date?: string;
                    /**
                     * @deprecated
                     * @description Last Name
                     * @example Doe
                     */
                    last_name?: string;
                    /**
                     * @deprecated
                     * @description Latest Bonus Code Consumed
                     * @example BONUSCON123
                     */
                    latest_bonus_code_consumed?: string;
                    /**
                     * Format: date-time
                     * @deprecated
                     * @description Latest Login Date
                     * @example 2020-01-01 00:00:00
                     */
                    latest_login_date?: string;
                    /**
                     * @deprecated
                     * @description Mobile
                     * @example
                     */
                    mobile?: string;
                    /**
                     * @deprecated
                     * @description Most Played Game Last 14 Days
                     * @example
                     */
                    most_played_game_last_14_days?: string;
                    /**
                     * @deprecated
                     * @description Most Popular Game Last 30 Days
                     * @example Game B
                     */
                    most_popular_game_last_30_days?: string;
                    /**
                     * @deprecated
                     * @description Name
                     * @example John Doe
                     */
                    name?: string;
                    /**
                     * @deprecated
                     * @description Old Email
                     * @example John@Doe.com
                     */
                    old_email?: string;
                    /**
                     * @deprecated
                     * @description Partner Name
                     * @example Partner A
                     */
                    partner_name?: string;
                    /**
                     * Format: number
                     * @deprecated
                     * @description Pending Bonus Amount
                     * @example 100.5
                     */
                    pending_bonus_amount?: unknown;
                    /**
                     * Format: number
                     * @deprecated
                     * @description Pending Bonus Minimum Deposit
                     * @example 50
                     */
                    pending_bonus_minimum_deposit?: unknown;
                    /**
                     * @deprecated
                     * @description Pending Bonus Type
                     * @example Type A
                     */
                    pending_bonus_type?: string;
                    /**
                     * @deprecated
                     * @description Player ID
                     * @example 12345
                     */
                    player_id: string;
                    /**
                     * @deprecated
                     * @description Recent Jackpot Game
                     * @example Game A
                     */
                    recent_jackpot_game?: string;
                    /**
                     * Format: date-time
                     * @deprecated
                     * @description Sent At
                     * @example 2020-01-01 00:00:00
                     */
                    sent_at: string;
                    /**
                     * @deprecated
                     * @description Sex
                     * @example male
                     */
                    sex?: string;
                    /**
                     * @deprecated
                     * @description Sign Up Code
                     * @example CODE123
                     */
                    sign_up_code?: string;
                    /**
                     * Format: date-time
                     * @deprecated
                     * @description Signed Up Date
                     * @example 2020-01-01 00:00:00
                     */
                    signed_up_date?: string;
                    /**
                     * Format: date-time
                     * @deprecated
                     * @description SMS Consent Given Date
                     * @example 2020-01-01 00:00:00
                     */
                    sms_consent_given_date?: string;
                    /**
                     * @deprecated
                     * @description SMS Link
                     * @example http://example.com/sms-link
                     */
                    sms_link?: string;
                    /**
                     * @deprecated
                     * @description Sub Partner Name
                     * @example Sub Partner B
                     */
                    sub_partner_name?: string;
                    /**
                     * @deprecated
                     * @description User Id
                     * @example 2
                     */
                    user_id: number;
                    /**
                     * @deprecated
                     * @description Verification Code
                     * @example VER123
                     */
                    verification_code?: string;
                    /**
                     * @deprecated
                     * @description Zipcode
                     * @example
                     */
                    zipcode?: string;
                };
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Provided argument is not an email */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "6beabf66c709169e52ecd7716583e147": {
        parameters: {
            query: {
                /** @description Timeslot end */
                end_date: string;
                /** @description Journey trigger */
                journey_trigger: string;
                /** @description Timeslot start */
                start_date: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Amount of contacts in journey by id who have received promotion mail within timeslot */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "3c0ed4d830f0ddb45c470509e6baddde": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /** @description Array of contacts to upsert (max 100) */
                    contacts: {
                        /** @description Player ID (UUID) */
                        player_id?: string;
                        /**
                         * Format: date-time
                         * @description Sent At
                         */
                        sent_at: string;
                        /** @description User Id */
                        user_id?: number;
                    }[];
                };
            };
        };
        responses: {
            /** @description Bulk update results */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    d551e135405a5da8981d478cf40c7dfd: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /**
                     * @description Also return the compiled SQL for the query
                     * @example false
                     */
                    explain?: boolean;
                    /**
                     * @description Query — same shape as /contacts/get
                     * @example {
                     *       "name": "John",
                     *       "age": 25,
                     *       "and": {
                     *         "email": "john@email.com"
                     *       }
                     *     }
                     */
                    query?: Record<string, never>;
                };
            };
        };
        responses: {
            /** @description Count of matching contacts, plus the compiled SQL when `explain` is set */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Malformed query */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    e35c238c3131b07eb4d7a88fd70b03b6: {
        parameters: {
            query?: {
                category?: string;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Contact-field catalog */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "7d1311d47ebf21b8d94d56026fa068fb": {
        parameters: {
            query?: {
                /** @description Fields */
                fields?: Record<string, never>;
                /** @description page number */
                page?: number;
                /** @description Per page */
                perPage?: number;
                /** @description Query */
                query?: Record<string, never>;
                /** @description Use simple pagination (no total count) */
                simplePaginate?: boolean;
            };
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /**
                     * @description Fields to return
                     * @example [
                     *       "player_id"
                     *     ]
                     */
                    fields?: Record<string, never>;
                    /**
                     * @description Page number
                     * @example 1
                     */
                    page?: number;
                    /**
                     * @description Number of items per page
                     * @example 250
                     */
                    perPage?: number;
                    /**
                     * @description Query
                     * @example {
                     *       "name": "John",
                     *       "age": 25,
                     *       "allowed_to_receive_email": false,
                     *       "and": {
                     *         "email": "john@email.com",
                     *         "old_email": "oldjohn@email.com"
                     *       },
                     *       "or": {
                     *         "mobile": "1234567890"
                     *       }
                     *     }
                     */
                    query?: Record<string, never>;
                    /**
                     * @description Use simple pagination (no total count)
                     * @example false
                     */
                    simplePaginate?: boolean;
                };
            };
        };
        responses: {
            /** @description Contacts */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    c40b332e83f3beaf06e7c7861403f2c8: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description id of the user for whom the mail should be sent */
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /**
                     * @description Current Brand
                     * @example happytiger
                     */
                    current_brand?: string;
                    /**
                     * @description Email
                     * @example John@Doe.com
                     */
                    email?: string;
                    /**
                     * @description Magic link
                     * @example https://spilnu.dk?token=token123456
                     */
                    magic_link?: string;
                    /**
                     * @description Requested by
                     * @example John Doe
                     */
                    requested_by?: string;
                    /**
                     * Format: date-time
                     * @description Sent At
                     * @example 2020-01-01 00:00:00
                     */
                    sent_at?: string;
                    /**
                     * @description Transactional Email Identifier
                     * @example test_email
                     */
                    transactional_email_identifier?: string;
                    /**
                     * @description User ID
                     * @example 1234
                     */
                    user_id?: number;
                };
            };
        };
        responses: {
            /** @description Email sent! */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "04d14b16927f8611a808d8aa7ecf1cba": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description id of the user for whom the marketing mail should be queued */
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /**
                     * @description Brand
                     * @example spilnu
                     */
                    brand: string;
                    /**
                     * @description Recipient email
                     * @example jane@example.com
                     */
                    email?: string;
                    /**
                     * @description Per-recipient merge fields
                     * @example {
                     *       "first_name": "Jane"
                     *     }
                     */
                    template_data?: Record<string, never>;
                    /**
                     * @description SendGrid Dynamic Template id
                     * @example d-abc123
                     */
                    template_id: string;
                    /**
                     * @description User ID
                     * @example 1234
                     */
                    user_id?: number;
                };
            };
        };
        responses: {
            /** @description Marketing email queued. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Rate limited */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    c92eec39f03664c79906ae92e31b0a10: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /** @example spilnu */
                    brand: string;
                    /** @example <html>…</html> */
                    compiled_html: string;
                    /** @example welcome_v1 */
                    slug: string;
                    /**
                     * @description Subject line stored on the provider template version (Handlebars allowed). Falls back to the design name when omitted.
                     * @example Hi {{first_name}}
                     */
                    subject?: string | null;
                    /** @example d-abc */
                    template_id?: string | null;
                };
            };
        };
        responses: {
            /** @description Design uploaded; provider identifiers returned. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Provider upload failed */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "2aec4e4c79dcdd1080fd3128dc8a9dce": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    active_names: string[];
                    /** @example 200 */
                    delete_cap: number;
                    /** @example 30 */
                    min_age_minutes: number;
                };
            };
        };
        responses: {
            /** @description Sweep done — returns deleted count + cap_hit flag. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "1652c017fae90cfe3e9783b529a558f5": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    template_ids: string[];
                };
            };
        };
        responses: {
            /** @description Templates deleted — returns {deleted:int}. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Provider delete failed */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    aad19c5f00b2980f9978e90662409236: {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /** @example spilnu */
                    brand: string;
                    /**
                     * Format: email
                     * @example hello@spilnu.dk
                     */
                    from_email?: string | null;
                    /** @example Spilnu */
                    from_name?: string | null;
                    /** @example <html>…</html> */
                    html: string;
                    /** @example sn_ip_pool */
                    ip_pool?: string | null;
                    /** @example [TEST] preview */
                    subject: string;
                    /**
                     * Format: email
                     * @example marketer@cego.dk
                     */
                    to: string;
                };
            };
        };
        responses: {
            /** @description Email sent — returns {sendgrid_message_id: string|null}. */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error, or provider not configured for brand. */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "67c3726617e5fe57ba05a81135052320": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /**
                     * @description Journey Trigger
                     * @example e362fcaf-7914-411a-8be0-c6dfacdac0f7
                     */
                    journey_trigger: string;
                    /**
                     * @description Player Ids
                     * @example [
                     *       "bb237d90-eb93-422e-a5cf-9b20761d4669",
                     *       "e6848053-1d8a-4148-8888-69ecf31ef45d",
                     *       "7c780be0-821e-40a1-9528-2a8102805c3c"
                     *     ]
                     */
                    player_ids: Record<string, never>;
                };
            };
        };
        responses: {
            /** @description Journey triggered for contacts */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Error message */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    bf9562c8b361dc3cc419b96dff7ee5bd: {
        parameters: {
            query?: {
                /** @description Brand filter */
                brand?: string;
                /** @description Channel filter (email, sms, push) */
                channel?: string;
                /** @description Event type filter (delivered, opened, ...) */
                event_type?: string;
                /** @description occurred_at lower bound (ISO 8601) */
                from?: string;
                /** @description Items (groups) per page */
                perPage?: number;
                /** @description Use simple pagination (no total count) */
                simplePaginate?: boolean;
                /** @description occurred_at upper bound (ISO 8601) */
                to?: string;
            };
            header?: never;
            path: {
                /** @description Player ID */
                playerId: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Message events grouped by message */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "871b0318e1410a8924107dd9f3125e50": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        /** @description Upsert Apple Ads Attribution Token. <br> Retries: 3. <br> Run: Every 4 hours. <br> Deletion: At night, after 3 retries or after 24 hours without updates. */
        requestBody: {
            content: {
                "application/json": {
                    /**
                     * @description Apple Ad Token
                     * @example e362fcaf-7914-411a-8be0-c6dfacdac0f7
                     */
                    apple_ads_token: string;
                    /**
                     * @description Device Id
                     * @example CF56F0FA-BAC4-47F8-BFC8-7277F6547740
                     */
                    device_id?: string;
                    /**
                     * @description Player Id
                     * @example bb237d90-eb93-422e-a5cf-9b20761d4669
                     */
                    player_id?: string;
                };
            };
        };
        responses: {
            /** @description Token has been upserted */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Validation Error */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Error message */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "3a6292e27ffb4259acfe5e37e4b9c23c": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /**
                     * @description Token from app installation
                     * @example e362fcaf-7914-411a-8be0-c6dfacdac0f7
                     */
                    app_token: string;
                    /**
                     * @description Brand of the app installed (spilnu | happytiger | spinking)
                     * @example spilnu
                     */
                    brand: string;
                    /**
                     * @description Journey Trigger
                     * @example iOS
                     */
                    os?: string;
                    /**
                     * @description Player Id
                     * @example bb237d90-eb93-422e-a5cf-9b20761d4669
                     */
                    player_id?: string;
                    /**
                     * @description Token state: active | disabled
                     * @example active
                     */
                    state: string;
                };
            };
        };
        responses: {
            /** @description Token has been upserted */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Error message */
            500: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    b3a35838f3e5b58b753f570baaaccaa1: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Random 32-character token from the email link; identifies the player, never accepted from any other input. */
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description Current consent state for the player identified by the token */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ConsentLinkState"];
                };
            };
            /** @description Token is missing, invalid, revoked or tampered with */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example Not found. */
                        message?: string;
                    };
                };
            };
            /** @description Rate limit exceeded for this IP or this token */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "80f848baa6b17a4eb18aa397ebca3b85": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Random 32-character token from the email link; identifies the player, never accepted from any other input. */
                token: string;
            };
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /** @example false */
                    enabled: boolean;
                    /**
                     * @example email_casino
                     * @enum {string}
                     */
                    type: PathsApiV1PublicUnsubscribeTokenPatchRequestBodyContentApplicationJsonType;
                };
            };
        };
        responses: {
            /** @description Consent state after applying the update */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": components["schemas"]["ConsentLinkState"];
                };
            };
            /** @description Token is missing, invalid, revoked or tampered with */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example Not found. */
                        message?: string;
                    };
                };
            };
            /** @description Invalid body, or a type not offered to this player */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Rate limit exceeded for this IP or this token */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "644120ac200ec26bd6dc753b1be5a719": {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description Random 32-character token from the email link; identifies the player, never accepted from any other input. */
                token: string;
            };
            cookie?: never;
        };
        requestBody?: never;
        responses: {
            /** @description All consent types were disabled; no content is returned */
            204: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Token is missing, invalid, revoked or tampered with */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example Not found. */
                        message?: string;
                    };
                };
            };
            /** @description Rate limit exceeded for this IP or this token */
            429: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    "7f9749d08f863b2e8316628bed38236d": {
        parameters: {
            query?: never;
            header?: never;
            path?: never;
            cookie?: never;
        };
        requestBody: {
            content: {
                "application/json": {
                    /** @example 555 */
                    player_id: string;
                };
            };
        };
        responses: {
            /** @description Revocation applied; every open consent-link token for this player no longer resolves */
            201: {
                headers: {
                    [name: string]: unknown;
                };
                content: {
                    "application/json": {
                        /** @example 555 */
                        player_id?: string;
                        /** @example 3 */
                        revoked_links?: number;
                    };
                };
            };
            /** @description No SSO session */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Missing player_id */
            422: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
    b2e0ad98655c96c1104d4af2003d4ab4: {
        parameters: {
            query?: never;
            header?: never;
            path: {
                /** @description User Id */
                user_id: string;
            };
            cookie?: never;
        };
        requestBody?: {
            content: {
                "application/json": {
                    /**
                     * @deprecated
                     * @description Email
                     * @example John@Doe.com
                     */
                    email?: string;
                    /**
                     * Format: date-time
                     * @deprecated
                     * @description Sent At
                     * @example 2020-01-01 00:00:00
                     */
                    sent_at: string;
                    /**
                     * @deprecated
                     * @description User Id
                     * @example 12345
                     */
                    user_id: number;
                };
            };
        };
        responses: {
            /** @description Unsubscribed */
            200: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Provided argument is not an email */
            400: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Unauthorized */
            401: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
            /** @description Not Found */
            404: {
                headers: {
                    [name: string]: unknown;
                };
                content?: never;
            };
        };
    };
}
export enum PathsApiV1ActivityAnalyticsSummaryGetParametersQueryChannel {
    email = "email",
    sms = "sms"
}
export enum PathsApiV1CallbacksSubscribeSmsTypePostParametersPathType {
    casino = "casino",
    bingo = "bingo"
}
export enum PathsApiV1PublicUnsubscribeTokenPatchRequestBodyContentApplicationJsonType {
    email = "email",
    email_casino = "email_casino",
    email_bingo = "email_bingo"
}
export enum ConsentLinkStateConsentsType {
    email = "email",
    email_casino = "email_casino",
    email_bingo = "email_bingo"
}
